// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"styles_formContainer__qJxSe","scrollbars":"styles_scrollbars__c0b_h","slideInSearchBar":"styles_slideInSearchBar__em11z"};